/** Tap the recorder stream. Closing this tap never stops microphone tracks. */
export function attachLiveAudio(stream:MediaStream,onSamples:(samples:Float32Array,rate:number)=>void,onUnavailable:()=>void){
  let closed=false,context:AudioContext|undefined,source:MediaStreamAudioSourceNode|undefined,node:AudioWorkletNode|undefined,mute:GainNode|undefined;
  const close=()=>{closed=true;if(node)node.port.onmessage=null;source?.disconnect();node?.disconnect();mute?.disconnect();void context?.close().catch(()=>undefined);};
  void (async()=>{
    try{
      const Ctor=globalThis.AudioContext??(globalThis as unknown as {webkitAudioContext?:typeof AudioContext}).webkitAudioContext;
      if(!Ctor)throw new Error('Audio unavailable');
      context=new Ctor();
      await context.audioWorklet.addModule(new URL('./voice-preview.worklet.js?no-inline',import.meta.url).href);
      if(closed)return;
      source=context.createMediaStreamSource(stream);node=new AudioWorkletNode(context,'worki-voice-preview');
      const rate=context.sampleRate;
      node.port.onmessage=(event:MessageEvent<Float32Array>)=>{if(!closed&&event.data instanceof Float32Array)onSamples(event.data,rate);};
      mute=context.createGain();mute.gain.value=0;source.connect(node);node.connect(mute);mute.connect(context.destination);
      await context.resume();
      if(closed)close();
    }catch{if(!closed)onUnavailable();close();}
  })();
  return {close};
}
